import { createI18n } from "vue-i18n";
import zh_CN from './zh-CN'
import zh_TW from './zh-TW'
import en from './zh-EN'
// import vi from './zh-VI'

// 语言库
export const messages = {
  'zh-CN': zh_CN,
  'zh-TW': zh_TW,
  'zh-EN': en,
  'zh-VI': en
}
// 默认语言
const langDefault = 'zh-CN'
// const langDefault = 'zh-EN'
// const langDefault = 'zh-TW'
// 同APP及后台传参别名
export const langAlias = {
  'zh-CN': {
    name: '中文简体',
    value: 'zh-CN',
    alias: 'zh-Hans'
  },
  'zh-TW': {
    name: '中文繁体',
    value: 'zh-TW',
    alias: 'zh-Hant'
  },
  'zh-EN': {
    name: '中文繁体',
    value: 'zh-EN',
    alias: 'en'
  },
  'zh-VI': {
    name: '中文繁体',
    value: 'zh-VI',
    alias: 'vi'
  }
}
const i18n = createI18n({
  legacy: false,
  locale: langDefault, // set locale
  messages // set locale messages
})

export default i18n